// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"_XPS1fq1","visible":"_s8I2GSp","container":"_16jMkkL","title":"_AYDgJMB","text":"_3uYD7jV","buttons":"_WYZmRtJ"};